import { OaScoreType } from '../models/oa-score-type.enum';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export const CoachingMyOaScoreTypeTranslationMap = {
    [OaScoreType.OA]: TranslationKeyMap._4000_MY_OA,
    [OaScoreType.Area_OA]: TranslationKeyMap._9904_MY_AREA,
    [OaScoreType.LOB_OA]: TranslationKeyMap._9905_MY_LOB,
    [OaScoreType.Peer_Group_OA]: TranslationKeyMap._9906_MY_PEERGROUP,
    [OaScoreType.Region_OA]: TranslationKeyMap._9907_MY_REGION,
    [OaScoreType.Site_OA]: TranslationKeyMap._9908_MY_SITE,
    [OaScoreType.Super_Group_OA]: TranslationKeyMap._9909_MY_SUPERGROUP,
    [OaScoreType.Other]: TranslationKeyMap._9603_OTHER,
};
